import { PhoneNumberService } from '@weave/schema-gen-ts/dist/schemas/phone/number-service/v2/number_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPhoneNumberV2Service = bindHTTP(PhoneNumberService);
export const serviceName = 'phone-number-v2' as const;
